import {
    ApolloLink,
    type FetchResult,
    type NextLink,
    Observable,
    type Operation,
} from '@apollo/client/core';
import type { Subscription } from 'zen-observable-ts';

export default class LazyLink<L extends ApolloLink> extends ApolloLink {
    private resolvedLink: L | null;

    constructor(private resolve: () => PromiseLike<L> | L) {
        super();
        this.resolvedLink = null;
    }

    public async getLink(): Promise<L> {
        if (!this.resolvedLink) {
            this.resolvedLink = await this.resolve();
        }
        return this.resolvedLink as L;
    }

    request(operation: Operation, forward?: NextLink): Observable<FetchResult> {
        return new Observable((observer) => {
            let subscription: Subscription | null = null;
            let unsubscribed = false;

            this.getLink()
                .then((link) => {
                    if (!unsubscribed) {
                        subscription =
                            link
                                .request(operation, forward)
                                ?.subscribe(observer) ?? subscription;
                    }
                })
                .catch((err) => {
                    observer.error(err);
                });

            return () => {
                unsubscribed = true;
                subscription?.unsubscribe();
            };
        });
    }
}

export function lazy<L extends ApolloLink>(
    resolve: () => PromiseLike<L> | L
): LazyLink<L> {
    return new LazyLink(resolve);
}
